import styled from 'styled-components'

export const ResultSorting = styled.div`
  .grid-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0;

    .sorting-label {
      padding-right: 10px;
    }
  }

  @media print {
    display: none;
  }
`
